<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
//ios 禁止放大缩小左右滑动
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
    };
  },
  created() {
  },
  watch: {
      $route() {
        if (window._czc) {
          let location = window.location;
          let contentUrl = location.pathname + location.hash;
          let refererUrl = "/";
          window._czc.push(["_trackPageview", contentUrl, refererUrl]);
        }
      }
  },
  mounted(){
    // 友盟统计添加
    const script = document.createElement("script");
    script.src = "https://s4.cnzz.com/z_stat.php?id=1281004600&web_id=1281004600";
    script.language = "JavaScript";
    document.body.appendChild(script);
  },
  methods: {
  },
};
</script>
<style lang="less">
@import "./assets/css/index.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  box-sizing: border-box;
}

// * {
//   margin: 0;
//   padding: 0;
// }
// html {
// }
body {
  // background: #ad0000 url("https://www.jinjinjin777.com/static/images/bg-pc-head.jpg") center top no-repeat;
  // background-size: 100% auto;
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  // min-height: 100vh;
}
button {
  border: none;
  outline: none;
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: white;
}
input {
  border: none;
  outline: none;
  box-sizing: border-box;
}
.subb {
  cursor: pointer;
}
p {
  color: white;
  font-size: 0.9375rem;
}
// span{
//   color: white;
// }
.navigation {
  color: rgb(209, 160, 38);
  text-align: left;
  margin: 1.25rem 0 0.625rem 0.625rem;
}
.login_pop {
  z-index: 999;
}
.content {
  width: 100%;
  background: #ad0000 url("./assets/index/bg-pc-head.jpg") center top no-repeat;
  background-size: 100% auto;
}
</style>
